export const ASSET_TYPES = {
    folder: 'folder',
    image: 'image',
    svg: 'svg',
    pdf: 'pdf',
    font: 'font',
    other: 'other',
};
